import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { createPerson } from 'services/people/actions';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import PersonForm from 'components/PersonForm';
import { PersonModal } from '../../constants';

interface StateProps {
    isOpen?: boolean;
}

interface DispatchProps {
    createPerson: Function;
    updateQueryString: Function;
}

type IProps = StateProps & DispatchProps;

export class PersonCreateModal extends React.PureComponent<IProps> {
    handleClose = () => {
        this.props.updateQueryString({
            [PersonModal.PERSON_CREATE_MODAL]: undefined,
            selectedPerson: undefined
        });
    };

    handleSubmit = (values: {}) => {
        this.props.createPerson(values);
    };

    render(): React.ReactElement {
        const { isOpen } = this.props;

        return (
            <Modal
                size="fullscreen"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="PersonCreateModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Create Person</Modal.Header>
                    <Modal.Content className="constrain-width">
                        <PersonForm
                            onClose={this.handleClose}
                            onSubmit={this.handleSubmit}
                        />
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isOpen: makeSelectQueryStringBooleanValue(PersonModal.PERSON_CREATE_MODAL)
});

export default connect<StateProps, DispatchProps>(mapStateToProps, {
    createPerson,
    updateQueryString
})(PersonCreateModal);
